import axios from 'axios';

// КРИТИЧНО: ВСЕГДА используем относительный путь для API
// Это гарантирует использование текущего протокола (HTTP/HTTPS) автоматически
// НЕ используем переменные окружения в продакшене, чтобы избежать проблем с Mixed Content

// Принудительно устанавливаем относительный путь - БЕЗ ВСЯКИХ ПРОВЕРОК
const baseURL = '/api';

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Переопределяем метод, который axios использует для формирования URL
// Это гарантирует, что даже если где-то был установлен абсолютный URL, он будет заменен
if (typeof axios.getUri === 'function') {
  const originalGetUri = axios.getUri;
  axios.getUri = function(config) {
    if (config && config.baseURL) {
      // Принудительно заменяем baseURL на относительный путь
      if (typeof config.baseURL === 'string' && 
          (config.baseURL.includes('http://') || 
           config.baseURL.includes('https://') || 
           config.baseURL.includes('www.roselearn.me') ||
           config.baseURL.includes('roselearn.me') ||
           !config.baseURL.startsWith('/'))) {
        console.error('Перехвачен абсолютный URL в getUri, заменяем на /api:', config.baseURL);
        config.baseURL = '/api';
      }
    }
    const uri = originalGetUri.call(this, config);
    // Дополнительная проверка результата
    if (uri && typeof uri === 'string' && 
        (uri.includes('http://www.roselearn.me') || uri.includes('http://roselearn.me'))) {
      console.error('КРИТИЧНО: getUri вернул абсолютный HTTP URL, исправляем:', uri);
      // Извлекаем путь из URI
      try {
        const urlObj = new URL(uri);
        return urlObj.pathname + urlObj.search;
      } catch (e) {
        const match = uri.match(/https?:\/\/[^\/]+(\/.*)/);
        return match ? match[1] : uri.replace(/^https?:\/\/[^\/]+/, '');
      }
    }
    return uri;
  };
}

// Перехватчик для исправления абсолютных URL с HTTP на HTTPS
// ВАЖНО: Этот interceptor выполняется ПЕРЕД формированием полного URL axios
api.interceptors.request.use((config) => {
  // КРИТИЧНО: ВСЕГДА принудительно устанавливаем относительный путь
  // Это гарантирует, что даже если где-то был установлен абсолютный URL, он будет заменен
  config.baseURL = '/api';
  
  // Исправляем url (относительный путь) - если это абсолютный URL
  if (config.url && typeof config.url === 'string') {
    // Если это абсолютный URL с http:// или https://, извлекаем только путь
    if (config.url.startsWith('http://') || config.url.startsWith('https://')) {
      try {
        const urlObj = new URL(config.url);
        config.url = urlObj.pathname + urlObj.search;
        console.error('КРИТИЧНО: Исправлен абсолютный URL в config.url на относительный путь:', config.url);
      } catch (e) {
        // Если не удалось распарсить, просто берем путь после домена
        const match = config.url.match(/https?:\/\/[^\/]+(\/.*)/);
        if (match) {
          config.url = match[1];
        } else {
          // Если не удалось извлечь путь, используем относительный путь
          config.url = config.url.replace(/^https?:\/\/[^\/]+/, '');
        }
        console.error('КРИТИЧНО: Исправлен абсолютный URL в config.url (через regex):', config.url);
      }
    }
    
    // Заменяем www.roselearn.me на относительный путь
    if (config.url.includes('www.roselearn.me') || config.url.includes('roselearn.me')) {
      const match = config.url.match(/https?:\/\/[^\/]+(\/.*)/);
      if (match) {
        config.url = match[1];
      } else {
        config.url = config.url.replace(/https?:\/\/[^\/]+/, '');
      }
      console.error('КРИТИЧНО: Исправлен URL с доменом на относительный путь:', config.url);
    }
  }
  
  // Финальная проверка: если baseURL все еще содержит абсолютный URL, принудительно заменяем
  if (config.baseURL && typeof config.baseURL === 'string') {
    if (config.baseURL.includes('http://') || config.baseURL.includes('https://') || 
        config.baseURL.includes('www.roselearn.me') || config.baseURL.includes('roselearn.me')) {
      console.error('КРИТИЧНО: Обнаружен абсолютный URL в baseURL, принудительно заменяем на /api:', config.baseURL);
      config.baseURL = '/api';
    }
  }
  
  // Дополнительная проверка: если baseURL не начинается с /, это ошибка
  if (config.baseURL && typeof config.baseURL === 'string' && !config.baseURL.startsWith('/')) {
    console.error('КРИТИЧНО: baseURL не является относительным путем, исправляем:', config.baseURL);
    config.baseURL = '/api';
  }
  
  // КРИТИЧНО: Проверяем, что config.url не содержит абсолютный URL
  if (config.url && typeof config.url === 'string') {
    // Если url содержит домен, извлекаем только путь
    if (config.url.includes('://') || config.url.includes('www.roselearn.me') || config.url.includes('roselearn.me')) {
      // Пытаемся извлечь путь из URL
      try {
        const urlObj = new URL(config.url);
        config.url = urlObj.pathname + urlObj.search;
        console.error('КРИТИЧНО: Извлечен путь из абсолютного URL:', config.url);
      } catch (e) {
        // Если не удалось распарсить, используем regex
        const match = config.url.match(/https?:\/\/[^\/]+(\/.*)/);
        if (match) {
          config.url = match[1];
        } else {
          // Удаляем все до первого /
          const pathIndex = config.url.indexOf('/');
          if (pathIndex !== -1) {
            config.url = config.url.substring(pathIndex);
          } else {
            config.url = '/' + config.url;
          }
        }
        console.error('КРИТИЧНО: Исправлен URL с доменом:', config.url);
      }
    }
  }
  
  // Логирование для отладки - ВСЕГДА логируем в продакшене для диагностики
  if (typeof window !== 'undefined' && 
      (window.location.hostname === 'roselearn.me' || window.location.hostname === 'www.roselearn.me')) {
    console.log('API Request Config:', {
      baseURL: config.baseURL,
      url: config.url,
      method: config.method,
      fullUrl: (config.baseURL || '') + (config.url || '')
    });
  }
  
  return config;
}, (error) => {
  console.error('Ошибка в request interceptor:', error);
  return Promise.reject(error);
});

// Дополнительная защита: перехватываем адаптер axios
// Это последний уровень защиты перед отправкой запроса
// Переопределяем метод request напрямую
const originalRequest = api.request;
api.request = function(config) {
  // Принудительно устанавливаем относительный путь
  if (config && config.baseURL && typeof config.baseURL === 'string') {
    if (config.baseURL.includes('http://') || 
        config.baseURL.includes('https://') || 
        config.baseURL.includes('www.roselearn.me') ||
        config.baseURL.includes('roselearn.me') ||
        !config.baseURL.startsWith('/')) {
      console.error('КРИТИЧНО: Request обнаружил абсолютный URL, исправляем:', config.baseURL);
      config.baseURL = '/api';
    }
  }
  
  // Проверяем url
  if (config && config.url && typeof config.url === 'string') {
    if (config.url.includes('http://www.roselearn.me') || 
        config.url.includes('http://roselearn.me') ||
        config.url.includes('https://www.roselearn.me') ||
        config.url.includes('https://roselearn.me')) {
      console.error('КРИТИЧНО: Request обнаружил абсолютный URL в url, исправляем:', config.url);
      try {
        const urlObj = new URL(config.url);
        config.url = urlObj.pathname + urlObj.search;
      } catch (e) {
        const match = config.url.match(/https?:\/\/[^\/]+(\/.*)/);
        if (match) {
          config.url = match[1];
        }
      }
    }
  }
  
  return originalRequest.call(this, config);
};

export default api;

